
import {Component, Vue} from "vue-property-decorator";
import Webservice from "@/assets/service/Webservice";
import {isLoggedIn} from "@/assets/utils/SessionUtils";

@Component({components: {}})
export default class End extends Vue {
    private message:string = "Sie wurden erfolgreich abgemeldet."

    mounted() {
        this.$store.commit("SET_ISINJECTED",false);
        this.$store.commit("SET_ENTRYPOINT",0);
        // Keine Navigation nach /logoff: ein Reload auf /end würde erneut /logoff
        // senden und eine Schleife auslösen. Ohne SID wird nicht abgemeldet.
        if (!isLoggedIn()) {
            return;
        }
        Webservice.logout(() => {
        }).catch(() => {
            this.message = "Abmeldung fehlgeschlagen.";
        });
    }

    private toLogin(): void {
        location.replace("/login");
    }
}